import Cookies from 'universal-cookie';

const cookies = new Cookies();

export default function useLoggedIn(): boolean {
  const authToken = cookies.get('authToken');
  return !!authToken;
}

